export const queueStatuses = [
  'STARTED',
  'PARSING',
  'WARMING',
  'PAUSED',
  'COMPLETE',
  'STOPPED',
  'FAILED',
  'LIMIT_REACHED',
];
export const completedStatuses = ['COMPLETE', 'STOPPED', 'FAILED'];
export const runningStatuses = ['STARTED', 'PARSING', 'WARMING', 'PAUSED'];



// WEBPACK FOOTER //
// ./src/modules/queues/enum.js